<!-- 予約/購入エラー -->
<template>
  <TemplateMfittBookingSalesEndError />
</template>

<script>
import TemplateMfittBookingSalesEndError from "@/views/Templates/MFITT/TemplateMfittBookingSalesEndError";

import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import API from "@/API";

export default {
  name: "MfittBookingSalesEndError",
  components: {
    TemplateMfittBookingSalesEndError,
  },
  setup() {},
};
</script>
